/**
 * Creates an object with REQUEST, SUCCESS, FAILURE, and RESET action types
 * @param {string} base - Base action name
 * @returns {Object} Object with action type variants
 */
const createActionTypes = (base) => ({
  REQUEST: `hospital/${base.toLowerCase()}-request`,
  SUCCESS: `hospital/${base.toLowerCase()}-success`,
  FAILURE: `hospital/${base.toLowerCase()}-failure`,
  RESET: `hospital/${base.toLowerCase()}-reset`
});

/**
   * Action types for generating and managing sharing keys
   */
export const shareKeyActions = {
  // Main operations
  GENERATE_KEY: createActionTypes('generate-key'),

  // Direct actions for key management
  SET_SHARE_KEY: 'hospital/set-share-key',
  CLEAR_SHARE_KEY: 'hospital/clear-share-key'
};
